// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__GZ4lH","MainPadding":"Spinner_MainPadding__jfn4D","Orange":"Spinner_Orange__04xqk","Gray":"Spinner_Gray__Fdv6V"};